import { render } from "./CheckupModal.vue?vue&type=template&id=78595f52"
import script from "./CheckupModal.vue?vue&type=script&lang=js"
export * from "./CheckupModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__